
import { defineComponent, reactive, ref, Ref } from "vue";
import { useI18n } from "vue-i18n";
import InputText from "@/components/primevueCustom/InputText.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import Button from "primevue/button";
import { IAlert } from "@/models/common";
import $API from "@/services";
import { messageType } from "@/models/message";

export default defineComponent({
  name: "Password",
  setup() {
    const state = reactive({
      password: "",
      newPassword: "",
      newPasswordConfirm: "",
    });
    const { t } = useI18n({ useScope: "global" });

    const changePassword = async () => {
      try {
        const success = await $API.SignService.changePassword(state.password, state.newPassword);
        if (success) {
          alert.value = {
            title: t("changePassword"),
            content: t("changed password"),
            type: messageType.INFO,
          };
        }
      } catch (ex) {
        alert.value = {
          title: t("changePassword"),
          content: t(ex.ResultData),
          type: messageType.ERROR,
        };
      }
    };

    const alert: Ref<IAlert> = ref({
      title: t("changePassword"),
      type: messageType.ERROR,
      content: "",
    });

    return {
      t,
      state,
      changePassword,
      alert,
    };
  },
  components: {
    InputText,
    Form,
    Field,
    ErrorMessage,
    Button,
  },
});
